module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event",
    class: _vm.expanded ? 'expanded' : ''
  }, [_c('button', {
    on: {
      "click": _vm.toggleExpanded
    }
  }, [_vm._v(">")]), _vm._v(" "), _c('header', {
    on: {
      "click": _vm.toggleExpanded
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.formattedDate))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.event.title))])]), _vm._v(" "), (_vm.expanded) ? _c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.event.title))]), _vm._v(" "), (_vm.event.location) ? _c('p', {
    staticClass: "lead"
  }, [_c('strong', [_vm._v(_vm._s(_vm.event.location))]), _c('br'), _vm._v(" "), (_vm.event.time) ? _c('span', [_vm._v(_vm._s(_vm.event.time))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "event-content",
    domProps: {
      "innerHTML": _vm._s(_vm.event.description)
    }
  }), _vm._v(" "), (_vm.event.register_link) ? _c('a', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "href": _vm.event.register_link,
      "target": "_blank"
    }
  }, [_vm._v("Register Now")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13836f3c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Event.vue
// module id = 306
// module chunks = 1